$( document ).ready(function() {
  $(".sector-container:nth-child(1) > .sectortile").addClass("notopborder1");
  $(".sector-container:nth-child(2) > .sectortile").addClass("notopborder2");
  $(".sector-container:nth-child(3) > .sectortile").addClass("notopborder3");
});